import schema from '@/framework/logic/schema/show-layout-component.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';

import setLayoutProperty from './setLayoutProperty';

const mapShowLayoutComponent = action => ({
  type: 'setLayoutProperty',
  data: {
    path: `components.${action.data}.properties.visible`,
    value: true,
  },
});

const validated = makeValidated(schema);

const showLayoutComponent = (context, event, meta) => {
  return setLayoutProperty(context, event, {
    action: mapShowLayoutComponent(
      validated(interpolate(meta.action, event, context))
    ),
  });
};

export default showLayoutComponent;
